import React from 'react'
import { Accessibility } from '../../src/components'

export default function AccessibilityPage() {
  return (
    <div className="cure-inner-container">
      <Accessibility />
    </div>
  )
}
